import { SearchQuery, SearchFilters } from 'common/store/common/search/types';
import commonSearchQueryBuilder, { AppSpecifiedSearchQueryBuildService } from 'common/services/search/commonSearchQueryBuilder';
import * as assessmentRunFields from '../../../docs/definitions/assessmentRunFields.json';
import * as assessmentRunQuestionFields from '../../../docs/definitions/assessmentRunQuestionFields.json';
import * as gradingPartyFields from '../../../docs/definitions/gradingPartyFields.json';
import * as userQuestionFields from '../../../docs/definitions/userQuestionFields.json';
import * as gradingReadyIssueFields from '../../../docs/definitions/gradingReadyIssueFields.json';
import {
    ASSESSMENTRUNQUESTION_INDEX,
    GRADING_PARTY_INDEX,
    USERQUESTION_INDEX,
    GRADINGREADY_ISSUE, ASSESSMENTRUN_INDEX,
} from '../../store/common/search/constants';
import { GradingPartyDocument } from '../gradingPartyService';
import { GradingPartySubmissionStatus } from '../../features/table/types';
import store from '../../store';
import { RootState } from '../../store/rootReducer';
import { AssessmentState } from '../../store/assessment/reducer';
import {
    AI_ASSISTED_MARKING_COLUMN_REF,
    isAiMarkingMarketplaceEnabled,
} from '../../features/aiSupportedMarkingIntro/guard';

const getFieldsForDataType = (dataType: string) => {
    switch (dataType) {
    case GRADING_PARTY_INDEX:
        return gradingPartyFields.default ? gradingPartyFields.default : gradingPartyFields;
    case USERQUESTION_INDEX:
        return userQuestionFields.default ? userQuestionFields.default : userQuestionFields;
    case ASSESSMENTRUNQUESTION_INDEX:
        return assessmentRunQuestionFields.default ? assessmentRunQuestionFields.default : assessmentRunQuestionFields;
    case GRADINGREADY_ISSUE:
        return gradingReadyIssueFields.default ? gradingReadyIssueFields.default : gradingReadyIssueFields;
    case ASSESSMENTRUN_INDEX:
        return assessmentRunFields.default ? assessmentRunFields.default : assessmentRunFields;
    default:
        return [];
    }
};

/**
 * Columns that are only offered when their marketplace property is switched on. Gating here rather
 * than in the permission filter keeps the rule next to the definitions it applies to.
 */
const isColumnEnabledForMarketplace = (column: { ref?: string }): boolean => (
    column?.ref !== AI_ASSISTED_MARKING_COLUMN_REF || isAiMarkingMarketplaceEnabled()
);

const searchQueryBuilderService: AppSpecifiedSearchQueryBuildService = {
    getColumnsDefinition(dataType: string) {
        return getFieldsForDataType(dataType).filter(isColumnEnabledForMarketplace);
    },
    createQueryFromGradingPartyDocument(gradingPartyDocument: GradingPartyDocument): SearchQuery {
        let searchQuery: SearchQuery = commonSearchQueryBuilder.createEmptyQuery();
        const filters: SearchFilters = {
            assessmentRunId: gradingPartyDocument.assessmentRunId,
            partyId: gradingPartyDocument.partyId,
        };
        searchQuery = commonSearchQueryBuilder.appendFilters(searchQuery, filters);
        return searchQuery;
    },
    appendSubmissionStatusFilter(searchQuery: SearchQuery, includeDeletedDeliveries = false): SearchQuery {
        const assessmentState: AssessmentState = (store.getState() as RootState).assessment;
        const submissionStatusFilter = [GradingPartySubmissionStatus.SUBMITTED];
        if (assessmentState.includeBlankDeliveries) {
            submissionStatusFilter.push(GradingPartySubmissionStatus.SUBMITTED_BLANK);
        }
        if (includeDeletedDeliveries) {
            submissionStatusFilter.push(GradingPartySubmissionStatus.DELETED);
        }
        const newSearchQuery = {
            ...searchQuery,
            filters: {
                ...searchQuery.filters,
                submissionStatus: submissionStatusFilter,
            },
        };
        return newSearchQuery;
    },
};

export default searchQueryBuilderService;
